import {
  Children,
  type ReactElement,
  cloneElement,
  isValidElement,
} from "react";
import { type TimelineStepProps } from "./TimelineStep";

interface TimelineProps {
  children: ReactElement<any> | ReactElement<any>[];
}

export const Timeline = ({ children }: TimelineProps) => {
  const childrenArray = Children.toArray(children);
  return (
    <>
      {childrenArray.map((child, idx) => {
        if (isValidElement<TimelineStepProps>(child)) {
          const isLast = idx === childrenArray.length - 1;
          return cloneElement(child, { isLast } as Partial<TimelineStepProps>);
        }
        return child;
      })}
    </>
  );
};
